import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviateNumber'
})
export class AbbreviateNumberPipe implements PipeTransform {
  transform(value: number, decimalPlaces: number = 1): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '-';
    }

    const absValue = Math.abs(value);

    if (absValue < 1000) {
      return value.toFixed(decimalPlaces);
    }

    const suffixes = ['', 'K', 'M', 'B', 'T', 'P', 'E'];

    const exp = Math.floor(Math.log10(absValue) / 3);

    const roundedValue = (value / Math.pow(10, exp * 3)).toFixed(decimalPlaces);

    if (roundedValue.endsWith('.0') || roundedValue.endsWith('.00')) {
      // If it's a whole number or has two zeros after the decimal, remove the decimal part
      return roundedValue.replace('.0', '').replace('.00', '') + suffixes[exp];
    } else {
      return roundedValue + suffixes[exp];
    }
  }
}
